var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3284 0.411687C16.22 0.302338 16.0909 0.215544 15.9488 0.156314C15.8066 0.0970837 15.6541 0.0665894 15.5001 0.0665894C15.3461 0.0665894 15.1936 0.0970837 15.0514 0.156314C14.9093 0.215544 14.7802 0.302338 14.6718 0.411687L5.9801 9.11502L2.32844 5.45169C2.21583 5.34291 2.0829 5.25738 1.93723 5.19997C1.79157 5.14257 1.63602 5.11441 1.47948 5.11712C1.32294 5.11983 1.16846 5.15335 1.02487 5.21576C0.881275 5.27816 0.751382 5.36825 0.642604 5.48085C0.533826 5.59346 0.448293 5.72639 0.390888 5.87206C0.333484 6.01772 0.305331 6.17327 0.30804 6.32981C0.310748 6.48636 0.344264 6.64083 0.406673 6.78442C0.469082 6.92802 0.559162 7.05791 0.671771 7.16669L5.15177 11.6467C5.26023 11.756 5.38926 11.8428 5.53143 11.9021C5.6736 11.9613 5.82609 11.9918 5.9801 11.9918C6.13412 11.9918 6.28661 11.9613 6.42878 11.9021C6.57095 11.8428 6.69998 11.756 6.80844 11.6467L16.3284 2.12669C16.4469 2.01744 16.5414 1.88484 16.606 1.73726C16.6707 1.58968 16.704 1.43031 16.704 1.26919C16.704 1.10807 16.6707 0.948696 16.606 0.801113C16.5414 0.65353 16.4469 0.520937 16.3284 0.411687Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e0a654688ca5231b6cfc6d022f058ea3.svg";
export { ForwardRef as ReactComponent };